<!-- TOP BAR -->
<div class="top-bar">
  <!-- <button class="back-btn" (click)="goBack()" aria-label="Back to product library">
      <span class="icon">‹</span> Back
    </button> -->
      <div style="display: flex;
    gap: 10px;">
    <button
      mat-icon-button
      matTooltip="Back"
      style="    width: fit-content;
    height: fit-content;
    line-height: normal;"
    (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
  </div>
  <!-- <div class="product-type">
    {{ product?.object_type__v_name__v || "—" }} :
  </div> -->
  <div class="top-right">
    <div class="info-title">
      {{
        product?.name__v || "—"
      }}
    </div>
    <!-- <div class="info-sub">Product ID: <strong>{{ product?.id }}</strong></div> -->
  </div>
</div>

<!-- PAGE LAYOUT -->
<div class="page-layout">
  <!-- SIDEBAR -->
  <!-- <aside class="sidebar" role="navigation" aria-label="Product sections">
    <h4 class="side-title">Sections</h4>
    <ul class="side-menu">
      <li
        *ngFor="let s of sections"
        (click)="scrollToSection(s.key)"
        [class.active]="activeSection === s.key"
        role="button"
        tabindex="0"
      >
        <span class="sm-text">{{ s.title }}</span>
      </li>
    </ul>
  </aside> -->

  <!-- MAIN CONTENT -->
  <main class="content" #mainContent>
    <section *ngFor="let s of sections" class="section-box" [id]="s.key">
      <button
        class="section-header"
        (click)="toggleSection(s.key)"
        [attr.aria-expanded]="sectionVisibility[s.key]"
      >
        <div class="header-left">
          <span class="section-icon" [class.rotated]="sectionVisibility[s.key]"
            >▼</span
          >
          <div class="header-title">{{ s.title }}</div>
        </div>
      </button>

      <div class="section-content" *ngIf="sectionVisibility[s.key]">
        <div class="form-grid">
          <!-- Use dynamic content for each section -->
          <ng-container [ngSwitch]="s.key">
            <!-- General Info -->
            <ng-container *ngSwitchCase="'generalInfo'">
              <div class="generalform-grid">
              <mat-form-field appearance="outline">
                <mat-label>Product Group Name</mat-label>
                <input
                  matInput
                  [value]="product?.product_groups || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Regulatory Status</mat-label>
                <input
                  matInput
                  [value]="product?.state__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Product Type</mat-label>
                <input
                  matInput
                  [value]="product?.object_type__v_name__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Internal Product Code</mat-label>
                <input
                  matInput
                  [value]="product?.abbreviation__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Generic Name</mat-label>
                <input
                  matInput
                  [value]="product?.generic_name__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>INN</mat-label>
                <input
                  matInput
                  [value]="product?.abbreviation__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Brand Name</mat-label>
                <input
                  matInput
                  [value]="product?.name__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>IBD</mat-label>
                <input
                  matInput
                  [value]="product?.international_birthdate__v || '–'"
                  readonly
                />
              </mat-form-field>
              <!-- <mat-form-field appearance="outline" class="full">
                <mat-label>Description</mat-label>
                <textarea
                  matInput
                  rows="3"
                  [value]="product?.manufacturer__v_name__v || '–'"
                  readonly
                ></textarea>
              </mat-form-field> -->
              </div>
            </ng-container>

            <!-- THERAPY INFO -->
            <ng-container *ngSwitchCase="'therapyInfo'">
              <ag-grid-angular
                class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                style="width: 100%; height: 320px"
                [columnDefs]="therapyColumnDefs"
                [animateRows]="true"
                [pagination]="true"
                [defaultColDef]="defaultColDef"
                [paginationPageSize]="3"
                [animateRows]="true"
                (gridReady)="onTherapyGridReady($event)"
                [gridOptions]="gridOptions"
                [enableBrowserTooltips]="true"
              ></ag-grid-angular>
            </ng-container>

            <!-- ADMINISTRATION -->
            <ng-container *ngSwitchCase="'administration'">
              <ag-grid-angular
                class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                style="width: 100%; height: 320px"
                [columnDefs]="administrationColumnDefs"
                [animateRows]="true"
                [pagination]="true"
                [defaultColDef]="defaultColDef"
                [paginationPageSize]="3"
                [animateRows]="true"
                (gridReady)="onAdminstartionGridReady($event)"
                [gridOptions]="gridOptions"
                [enableBrowserTooltips]="true"
              ></ag-grid-angular>
            </ng-container>

            <!-- LITERATURE -->
            <ng-container *ngSwitchCase="'literatureInfo'">
              <ag-grid-angular
                class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                style="width: 100%; height: 320px"
                [columnDefs]="literatureColumnDefs"
                [animateRows]="true"
                [pagination]="true"
                [defaultColDef]="defaultColDef"
                [paginationPageSize]="3"
                [animateRows]="true"
                (gridReady)="onLiteratureGridReady($event)"
                [gridOptions]="gridOptions"
                [enableBrowserTooltips]="true"
              ></ag-grid-angular>
            </ng-container>

            <!-- Device Info -->
            <ng-container *ngSwitchCase="'deviceInfo'">
              <mat-form-field appearance="outline">
                <mat-label>UDI</mat-label>
                <input
                  matInput
                  [value]="product?.deviceInfo?.udi || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Device Identifier</mat-label>
                <input
                  matInput
                  [value]="product?.deviceInfo?.deviceIdentifier || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>GMDN Code</mat-label>
                <input
                  matInput
                  [value]="product?.deviceInfo?.gmdn || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>UMDC Code</mat-label>
                <input
                  matInput
                  [value]="product?.deviceInfo?.umdc || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Risk Class</mat-label>
                <input
                  matInput
                  [value]="product?.deviceInfo?.riskClass || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Product Category</mat-label>
                <input
                  matInput
                  [value]="product?.deviceInfo?.productCategory || '–'"
                  readonly
                />
              </mat-form-field>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </section>
  </main>
</div>
